module.exports = __webpack_public_path__ + "img/document.f8fd89a0.svg";